import { useContext } from 'react'
import { KendraContext } from '../context/KendraContext'

const useKendra = () => {
    return useContext(KendraContext)
}
export default useKendra